import { jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import Tooltip$1, { tooltipClasses } from "@mui/material/Tooltip";
const Tooltip = styled(({
  className,
  ...props
}) => /* @__PURE__ */ jsx(Tooltip$1, { ...props, classes: {
  popper: className
} }))(({
  theme
}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    display: "flex",
    padding: theme.sizes.spacing["06"],
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.sizes.spacing["02"],
    alignSelf: "stretch",
    overflowWrap: "anywhere",
    background: "rgba(19, 18, 16, 0.80)",
    fontFamily: theme.fonts.family.body,
    fontStyle: "normal",
    fontWeight: theme.fonts.weight.normal,
    color: theme.colors.text.inverted,
    fontSize: theme.fonts.size.sm,
    borderRadius: theme.sizes.radius.md,
    boxShadow: "0px 12px 16px -4px rgba(36, 5, 5, 0.12), 0px 4px 6px -2px rgba(36, 5, 5, 0.06)"
  }
}));
export {
  Tooltip as default
};
